export default __webpack_public_path__ + "static/media/galaxy.6376a942.png";